export const UNDUE_PAYMENT_STAGES = {
  INITIAL: 'initial',
}
